import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"; // para leer el token de la URL
import iconValidateDocument from "../../../assets/img/verificacion-de-documentos.svg";
import * as constantes from '../../../constants/constantes.js';

import './ValidateCertificateQR.scss';

function ValidateCertificateQR() {
  
  const ENDPOINT = constantes.URLAPI;
  const [searchParams] = useSearchParams();
  const [mensajeError, setMensajeError] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const codigo = searchParams.get("codigo"); // Token desde la URL
  const tipo = searchParams.get("tipo"); // Token desde la URL

  useEffect(() => {

    if (codigo) {
        const jsonData = JSON.stringify({
          CodigoCertificado: codigo
        });

      buscarCertificado(jsonData);
    }
  }, [codigo, tipo]);

     const buscarCertificado = async (jsonData) => {
        try {
            const response = await fetch(`${ENDPOINT}/ZADCertiicados/FValidateCertificateQR`,{   
            //const response = await fetch('http://localhost:7071/api/FValidateCertificateQR', {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: jsonData,
            });

            if (response.ok) {
              const result = await response.json();
              setData(result.data);
              setMensajeError("");

            } else {
              const result = await response.json();
              setMensajeError(result.message || "Error ....");
              setData(null);
            }
            

        } catch (error) {
          setMensajeError("Error de conexión con el servidor");
          setData(null);
        } finally {
          setLoading(false);
        }
  };

    return (
        <>
    <div className="verificacion">
      <div className="verificacion__header">
        <h2>Verificación de certificados</h2>
        {/* <p>
          Por favor, bríndanos el código de verificación de la constancia o certificado emitido.
        </p> */}
      </div>
      <div className="verificacion__contenido">
        <div className="verificacion__imagen">
          <img src={iconValidateDocument} alt="Certificado" />
        </div>

        {loading ? (
          <p>Cargando...</p>
        ) : mensajeError ? (
          <p>{mensajeError}</p>
        ) : data ? (
          <div className="verificacion__info">
            <h3>El documento es válido</h3>
            {tipo === '1' ? (
              <p>
                El código <strong>{data.codigoCertificado}</strong>, corresponde al alumno <strong>{data.nombreCompleto}</strong>, con <strong>DNI/CE {data.dni}</strong> y al {data.tipo == "Curso" ? data.tipo : ""} <strong>{data.cursoPrograma}</strong> emitido el <strong>{data.fechaEmision}</strong>.
              </p>
            ) : (
              <p>
                El código <strong>{data.codigoCertificado}</strong>, corresponde al alumno <strong>{data.nombreCompleto}</strong>, con <strong>DNI/CE {data.dni}</strong> y al detalle de notas del {data.tipo == "Curso" ? data.tipo : ""} <strong>{data.cursoPrograma}</strong> emitido el <strong>{data.fechaEmision}</strong>.
              </p>
            )}
          </div>
        ) : (
          <p>El documento no es válido</p>
        )}
      </div>
    </div>
      
    </>
      )
    }
    
    export default ValidateCertificateQR